import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import AllContent from '../AllContent';
import GeneratedDownloads from './GeneratedDownloads';
import GlobalSearch from '../../hoc/Layout/GlobalSearch';
import styles from './Admin.module.scss';

const Admin = () => {
  const history = useHistory();
  const location = useLocation();
  const activeSection = new URLSearchParams(location.search).get('section') === 'downloads' ? 'downloads' : 'content';

  const selectSection = (section: 'content' | 'downloads') => {
    history.replace({
      pathname: location.pathname,
      search: section === 'downloads' ? '?section=downloads' : '',
    });
  };

  return (
    <div className={styles.admin}>
      <div className={styles.topBar}>
        <div className={styles.smallPath}>File Management</div>
        <div className={styles.pageTitle}>Admin</div>
      </div>
      <div className={styles.layout}>
        <nav className={styles.sidebar}>
          <div className={styles.globalSearch}>
            <GlobalSearch allContent />
          </div>
          <button
            className={activeSection === 'content' ? styles.active : ''}
            onClick={() => selectSection('content')}
            type="button"
          >
            Content Admin
          </button>
          <button
            className={activeSection === 'downloads' ? styles.active : ''}
            onClick={() => selectSection('downloads')}
            type="button"
          >
            Generated Downloads
          </button>
        </nav>
        <main className={styles.content}>{activeSection === 'downloads' ? <GeneratedDownloads /> : <AllContent />}</main>
      </div>
    </div>
  );
};

export default Admin;
